import { useCallback, useEffect, useRef } from "react";
import { io } from "socket.io-client";

/**
 * useSocket
 * Connects to the backend socket.io server, joins the current user's room,
 * and calls onNewMessage whenever a "new_message" event arrives.
 *
 * @param {string} userId        — current user's _id
 * @param {function} onNewMessage — ({ requirementId, requirementName, message }) => void
 */
console.log("****************");
export default function useSocket(userId, onNewMessage) {
  const socketRef = useRef(null);
  // http://localhost:9003
  useEffect(() => {
    if (!userId) return;
    console.log("Socket Entered.....");
    const URL = "https://rmt.cloudstakes.com/";

    const socket = io(URL, {
      path: "/api/socket.io",
      transports: ["websocket"],
    });

    socketRef.current = socket;

    socket.on("connection", () => {
      console.log("Connected:", socket.id);
      socket.emit("join", userId);
    });
    socket.on("connect_error", (err) => {
      console.error("Socket Error:", err);
    });

    // Listen for new messages directed at this user
    socket.on("new_message", (payload) => {
      console.log("Connected Message:", socket.id);
      onNewMessage(payload);
    });

    return () => {
      socket.disconnect();
      socketRef.current = null;
    };
  }, [userId, onNewMessage]); // reconnect only if userId changes
  const watchRequirement = useCallback((requirementId) => {
    if (socketRef.current && requirementId) {
      socketRef.current.emit("watch_requirement", requirementId);
    }
  }, []);

  // Call when drawer closes
  const unwatchRequirement = useCallback((requirementId) => {
    if (socketRef.current && requirementId) {
      socketRef.current.emit("unwatch_requirement", requirementId);
    }
  }, []);

  return { watchRequirement, unwatchRequirement };
}
